import script from "./ProviderCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProviderCard.vue?vue&type=script&setup=true&lang=ts"

import "./ProviderCard.vue?vue&type=style&index=0&id=642c0d64&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-642c0d64"]])

export default __exports__